import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {SMALL_TEXT_PX,DISABLED_FONT_COLOR,X_SMALL_TEXT_PX
    } from 'src/styles/fonts/MCFontConstants';
import { SECONDARY_FONT_COLOR, WHITE_FONT_COLOR } from '../../../styles/fonts/MCFontConstants';

export const PaginationInfo = styled.div`
    justify-content: ${({ JustifyContent }) =>
        JustifyContent ? JustifyContent : 'center'};
    display: ${({ Display }) => (Display ? Display : '')};
    align-items: ${({ AlignItems }) => (AlignItems ? AlignItems : '')};
    align-self: ${({ alignSelf }) => (alignSelf ? alignSelf : '')};
    margin: ${({ margin, isCondensedView, marginKB }) =>
        margin && !isCondensedView
            ? margin
            : marginKB
            ? marginKB
            : '0px 0px 0px 10px'};
    font-family: 'AvenirNextWorld Demi';
    font-size: ${SMALL_TEXT_PX};
    width: 40%;
    padding: 8px 0;
    ${media.mediumDevice`
        margin: ${({ipadPaginationInfoMargin})=> ipadPaginationInfoMargin? ipadPaginationInfoMargin : 'auto' };
        width: ${({ iPadPaginatorInfoWidth }) =>
            iPadPaginatorInfoWidth ? iPadPaginatorInfoWidth : '40%'};
        text-align: ${({ textAlign }) => textAlign};
    `}
    ${media.smalDevice`
        margin: auto;
        width: ${({ iPadPaginatorInfoWidth }) =>
            iPadPaginatorInfoWidth ? iPadPaginatorInfoWidth : '40%'};
        text-align: ${({ textAlign }) => textAlign};
    `}
    ${media.mobileDevice`
        width: 100%;
        margin: auto;
    `}
    ${media.mobileDevice`
        margin-top: 5px;
        font-size: ${X_SMALL_TEXT_PX};
        text-align: center;
        margin: auto;
    `}
    color: ${SECONDARY_FONT_COLOR}; 
    @media only screen and (min-device-width: 768px) and (max-device-width: 770px) {
        margin-left: ${({ isCondensedView, marginLeft, marginSurgery }) =>
            marginLeft === '20px'
                ? '20px'
                : marginSurgery
                ? isCondensedView && '20px'
                : isCondensedView && '10px'};
        text-align: ${({ isCondensedView }) => isCondensedView && 'left'};
        flex-direction: ${({ isCondensedView }) => isCondensedView && 'row'};
    }
    @media only screen and (min-device-width: 1027px) {
        margin-left: ${({ marginLeft }) => marginLeft ? marginLeft : '20px'};
        margin-top:${({ marginSurgery,marginPaginationInfo }) => (!marginPaginationInfo && 
                    marginSurgery)? '8px' : '0'}; 
        align-self: ${({ alignSelfCenter }) => alignSelfCenter ? 'center':''}; 
    }
    @media only screen and (min-device-width: 820px) and (max-device-width: 830px) {
        margin-left: ${({ isCondensedView, marginLeft, marginSurgery }) =>
            marginLeft === '20px'
                ? '20px'
                : marginLeft === '-125px'
                ? '-45px'
                : marginSurgery
                ? isCondensedView && '20px'
                : isCondensedView && '10px'};
        text-align: ${({ isCondensedView }) => isCondensedView && 'left'};
    }
    @media only screen and (min-device-width: 1024px) and (max-device-width: 1025px) {
        margin-left: ${({ isCondensedView, marginLeft, marginSurgery }) =>
            marginLeft === '20px'
                ? '25px'
                : marginSurgery
                ? isCondensedView && '23px'
                : isCondensedView && '10px'};
        text-align: ${({ isCondensedView }) => isCondensedView && 'left'};
        margin-top: ${({ isCondensedView, marginLeft, marginSurgery }) =>
            marginSurgery ? isCondensedView && '0px' : ''};
        flex: ${({ flexGrow }) =>
            flexGrow ? flexGrow : ''};
    }
`;
export const PaginationPanel = styled.div`
    margin: auto;
    justify-content: space-between;
    flex-wrap: wrap;
    display: flex;
    padding: 0px 23px;
    ${media.smalDevice`
        justify-content: space-evenly;
    `}

    ${media.mediumDevice`
        justify-content: space-evenly;
    `}
    
    ${media.mobileDevice`
        justify-content: space-evenly;
    `}
`;

export const PaginatorContainer = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    ${media.mediumDevice`
        padding: ${({ iPadPaginationPadding }) => iPadPaginationPadding && iPadPaginationPadding};
        width: ${({ ipadWidth }) => (ipadWidth ? ipadWidth : '100%')};
        flex-direction:  ${({ flexDirection }) =>
            flexDirection ? flexDirection : 'row'};
    `}
    ${media.smalDevice`
            flex-direction:  ${({ flexDirection }) =>
                flexDirection ? flexDirection : 'row'};
    `}
        
@media only screen and (min-device-width: 1024px) and (max-device-width: 1026px) {
        flex-direction: ${({ isCondensedView }) => isCondensedView && 'row'};
    }
    @media only screen and (min-device-width: 768px) and (max-device-width: 770px) {
        flex-direction: ${({ isCondensedView }) => isCondensedView && 'row'};
        align-items: ${({ isCondensedView }) => isCondensedView && 'row'};
        justify-content: ${({ isCondensedView }) =>
            isCondensedView && 'center'};
        min-width: ${({ isCondensedView }) => isCondensedView && '400px'};
        margin: ${({ isCondensedView }) => isCondensedView && 'auto'};
        gap: ${({ isCondensedView }) => isCondensedView && '30px'};
    }
    @media only screen and (min-device-width: 820px) and (max-device-width: 830px) {
        flex-direction: ${({ isCondensedView }) => isCondensedView && 'row'};
        align-items: ${({ isCondensedView }) => isCondensedView && 'row'};
        justify-content: ${({ isCondensedView }) =>
            isCondensedView && 'center'};
        min-width: ${({ isCondensedView }) => isCondensedView && '400px'};
        margin: ${({ isCondensedView }) => isCondensedView && 'auto'};
        gap: ${({ isCondensedView }) => isCondensedView && '70px'};
    }
    @media only screen and (min-device-width: 810px) and (max-device-width: 810px) and (orientation: portrait) {
        padding-left: 1%;
    }
    .p-paginator {
        background: none;
        width: ${({ width }) => width ? width: '60%'};
        justify-content: flex-end;
        padding-top: ${({ paddingTop }) => paddingTop && paddingTop};

        margin-right: ${({ marginRight }) => marginRight && '8px'};
        
        margin: ${({ linkMargin }) => linkMargin};
        padding:${({ linkPadding }) => linkPadding};

        @media only screen and (min-device-width: 1024px) and (max-device-width: 1026px) {
            margin-right: ${({
                isCondensedView,
                marginRightKB,
                marginSurgery,
                ipadPopupNoMarginRight
            }) =>
                marginRightKB === '-30px'
                    ? '-60px'
                    : marginSurgery
                    ? isCondensedView && '10px'
                    : isCondensedView && ipadPopupNoMarginRight? '0': 
                    (isCondensedView && !ipadPopupNoMarginRight) && '-20px'};
            flex-direction: ${({ flexDirection }) => flexDirection && 'row'};
        }
        @media only screen and (min-device-width: 768px) and (max-device-width: 770px) and (orientation: landscape) {
            margin-right: ${({
                isCondensedView,
                isFromIndependentProductGuide
            }) =>
                isCondensedView && !isFromIndependentProductGuide && '25px'};
        }
        @media only screen and (min-device-width: 768px) and (max-device-width: 770px) {
            margin-right: ${({
                isCondensedView,
                marginRightKB,
                marginSurgery,
                ipadPopupNoMarginRight
            }) =>
                marginRightKB === '-30px'
                    ? '-15px'
                    : marginSurgery
                    ? isCondensedView && '0px'
                    : isCondensedView && ipadPopupNoMarginRight? '0': 
                    (isCondensedView && !ipadPopupNoMarginRight) && '-20px'};
            flex-direction: ${({ isCondensedView }) =>
                isCondensedView && 'row'};
        }
        @media only screen and (min-device-width: 820px) and (max-device-width: 830px) {
            margin-right: ${({
                isCondensedView,
                marginRightKB,
                marginSurgery,
                ipadPopupNoMarginRight
            }) =>
                marginRightKB === '-30px'
                    ? '-20px'
                    : marginSurgery
                    ? isCondensedView && '0px'
                    : isCondensedView && ipadPopupNoMarginRight? '0': 
                    (isCondensedView && !ipadPopupNoMarginRight) && '-20px'};
            flex-direction: ${({ isCondensedView }) =>
                isCondensedView && 'row'};
        }
        ${media.mediumDevice`
            width: ${({ iPadPaginatorWidth }) =>
                iPadPaginatorWidth ? iPadPaginatorWidth : '60%'};
            justify-content: ${({ iPadPaginatorJustifyContent }) =>
                iPadPaginatorJustifyContent
                    ? iPadPaginatorJustifyContent
                    : 'flex-end'};
            flex: ${({ flexGrow }) =>
                flexGrow && 1};
        `}
        ${media.smalDevice`
            width: ${({ iPadPaginatorWidth }) =>
                iPadPaginatorWidth ? iPadPaginatorWidth : '60%'};
            justify-content: ${({ iPadPaginatorJustifyContent }) =>
                iPadPaginatorJustifyContent
                    ? iPadPaginatorJustifyContent
                    : 'flex-end'};
        `}
        ${media.mobileDevice`
            width: 100%;
            justify-content: center;
            flex-direction:row;
            padding: ${({ mobilePadding }) =>
                mobilePadding ? mobilePadding : 'unset'}; 
        `}
    }
    .p-paginator-bottom {
        font-family: AvenirNextWorld Demi;
        line-height: 25px;
        background-color: #f5f5f5;
        box-shadow: 0;
        border: none;
        padding: 18px 0 0 0;
    }
    .p-paginator-pages {
        font-family: AvenirNextWorld Demi;
        display: flex;
        line-height: 22px;
        padding-bottom: ${({ paddingBottom }) =>
            paddingBottom && paddingBottom};
        & > p {
            line-height: 22px;
            margin-top: 0;
            margin-bottom: 0 !important;
        }
    }

    ${media.mobileDevice`
        display: block;
    `}
`;

export const StyledPageLink = styled.div`
    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
    margin: ${({margin}) => (margin && margin)};
    position: ${({ position }) => (position && position)};
    width: ${({ width }) => (width ? width : 'auto')};
    height: ${({ height }) => (height ? height : 'auto')};
`;

export const PageNumLink = styled.p.attrs(({ pageNumber, selected }) => ({
    id: `page-link-${pageNumber || 'default'}`,
    'data-selected': selected ? 'true' : undefined,
}))`
    border-radius: ${({ hasLength }) => (hasLength? '50%' : '20px')}; 
    margin-left: ${({ baseMargin }) => (baseMargin)};
    margin-right: ${({ baseMargin }) => (baseMargin)};
    cursor: pointer;
    width:  ${({ hasLength }) => ( hasLength ? '40px' : '22px')};
    height:  ${({ hasLength }) => (hasLength? '27px' : '22px')};
    text-align: center;
    font-size: ${SMALL_TEXT_PX};
    border:  ${({ selected }) => (selected 
        ? '1px solid black' 
        : '')};
    background:   ${({ selected }) => (selected 
        ? '0% 0% no-repeat padding-box padding-box #4f4f4f'
        : '')};
    opacity:  ${({ selected }) => (selected  ? 1 : '')};
    color:  ${({ selected }) => (selected  ? WHITE_FONT_COLOR : DISABLED_FONT_COLOR)};
    margin-bottom: '10px';
    padding-top: ${({ hasLength }) => (hasLength?'2px' : '')};
`;
